module.exports = __webpack_public_path__ + "static/media/myBookingsGreen.0e21f2c4.svg";